import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetGeneralInformationData = createAsyncThunk(
  "AI_GeneralInformation/GetGeneralInformationData",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AI_GeneralInformation/GetGeneralInformationData",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      // //console.log(data,"dataaaaaaaaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const GeneralInformation = createSlice({
  name: "GeneralInformation",
  initialState: {
    GeneralInformation: {},
    loadingGeneralInformation: false,
    errorGeneralInformation: null,
    
  },
  reducers: {
    SetGeneralInformation: (state, action) => {
      state.GeneralInformation = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetGeneralInformationData.pending, (state, action) => {
        state.loadingGeneralInformation = true;
        state.GeneralInformation = action.payload;
        state.errorGeneralInformation = null;
      })
      .addCase(GetGeneralInformationData.fulfilled, (state, action) => {
        state.loadingGeneralInformation = false;
        state.GeneralInformation = action.payload;
      })
      .addCase(GetGeneralInformationData.rejected, (state, action) => {
        state.loadingGeneralInformation = false;
        state.errorGeneralInformation = action.payload;
      });
  },
});

export const { SetGeneralInformation } = GeneralInformation.actions;

export default GeneralInformation.reducer;
